import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Modal from '@mui/material/Modal';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import useTheme from '@mui/material/styles/useTheme';
import CustomTheme from '../../../styles/theme';
import CloseIcon from '@assets/icons/close-icon-green.svg';
import SearchIcon from '@assets/icons/search-icon.svg';
import UpArrow from '@assets/icons/up-arrow.svg';
import dataLayerService from '../../../services/data-layer-service';
import useMediaQuery from '@mui/material/useMediaQuery';
import { toTitleCase } from '../../../utils/utils';
import AdnThinking from '@assets/images/adn-thinking.png';
import './custom-select-field.scss';
const CustomSelectField = (customSelectFieldProps) => {
    const theme = useTheme();
    const { onChangeExtern, data, value, name, titleModal, messageError, searchAutoFocus, isOcupation, subZone, imgAdvise, titleAdvise, subtitleAdvise, ...props } = customSelectFieldProps;
    const [opeSelectModal, setOpeSelectModal] = useState(false);
    const [filteredData, setFilteredData] = useState(data);
    const [dataSelected, setDataSelected] = useState({ label: '', value: '' });
    const [error, setError] = useState(false);
    const isMobile = useMediaQuery('(max-width: 600px)');
    const closeModalOccupation = () => {
        setFilteredData(data);
        setOpeSelectModal(false);
        setError(value === '');
    };
    const searchAutoFocusValue = searchAutoFocus === undefined ? true : searchAutoFocus;
    const filterOccupation = (event) => {
        const value = event.target.value.toLowerCase();
        let occupationsFiltered = data.filter(occupation => {
            return occupation.label.toLowerCase().includes(value);
        });
        setFilteredData(occupationsFiltered);
    };
    const filterPlaceofBirth = (event) => {
        const value = event.target.value;
        let occupationsFiltered = data.filter(occupation => {
            return occupation.label.toLowerCase().startsWith(value.toLowerCase());
        });
        setFilteredData(occupationsFiltered);
    };
    const changeRadioButton = (_, value) => {
        setError(false);
        let birthPlace, occupation, livingDepartment, livingProvince, livingDistrict;
        switch (name) {
            case 'birthPlace':
                birthPlace = data.find(element => element.value === value);
                setDataSelected(birthPlace);
                if (birthPlace) {
                    onChangeExtern({ name: 'birthPlace', value: birthPlace.value });
                    setOpeSelectModal(false);
                    handleDataLayer('Paso1_SeleccionDepartamento', birthPlace.label, subZone, true);
                }
                break;
            case 'occupation':
                occupation = data.find(element => element.value === value);
                setDataSelected(occupation);
                if (occupation) {
                    onChangeExtern({ name: 'occupation', value: occupation.value });
                    setOpeSelectModal(false);
                    handleDataLayer('Selección_Profesión', occupation.label, subZone, false);
                }
                break;
            case 'livingDepartment':
                livingDepartment = data.find(element => element.value === value);
                setDataSelected(livingDepartment);
                if (livingDepartment) {
                    onChangeExtern({ name: 'livingDepartment', value: livingDepartment.value });
                    setOpeSelectModal(false);
                    handleDataLayerProvDistrict('Paso2_SeleccionDepartamentoResidencia', livingDepartment.label, 'Paso 2', subZone);
                }
                break;
            case 'livingProvince':
                livingProvince = data.find(element => element.value === value);
                setDataSelected(livingProvince);
                if (livingProvince) {
                    onChangeExtern({ name: 'livingProvince', value: livingProvince.value });
                    setOpeSelectModal(false);
                    handleDataLayerProvDistrict('Paso2_SeleccionProvinciaResidencia', livingProvince.label, 'Paso 2', subZone);
                }
                break;
            case 'livingDistrict':
                livingDistrict = data.find(element => element.value === value);
                setDataSelected(livingDistrict);
                if (livingDistrict) {
                    onChangeExtern({ name: 'livingDistrict', value: livingDistrict.value });
                    setOpeSelectModal(false);
                    handleDataLayerProvDistrict('Paso2_SeleccionDistritoResidencia', livingDistrict.label, 'Paso 2', subZone);
                }
                break;
            default:
                occupation = data.find(element => element.value === value);
                setDataSelected(occupation);
                if (occupation) {
                    onChangeExtern({ name: 'occupation', value: occupation.value });
                    setOpeSelectModal(false);
                    handleDataLayer('Selección_Profesión', occupation.label, subZone, false);
                }
                break;
        }
    };
    useEffect(() => {
        setPrevData();
    }, []);
    const setPrevData = () => {
        let livingDepartment, livingProvince;
        switch (name) {
            case 'livingDepartment':
                livingDepartment = data.find(element => element.value === value);
                setDataSelected(livingDepartment);
                if (livingDepartment) {
                    onChangeExtern({ name: 'livingDepartment', value: livingDepartment.value });
                    setOpeSelectModal(false);
                    handleDataLayerProvDistrict('Paso2_SeleccionDepartamentoResidencia', livingDepartment.label, 'Paso 2', subZone);
                }
                break;
            case 'livingProvince':
                livingProvince = data.find(element => element.value === value);
                setDataSelected(livingProvince);
                if (livingProvince) {
                    onChangeExtern({ name: 'livingProvince', value: livingProvince.value });
                    setOpeSelectModal(false);
                    handleDataLayerProvDistrict('Paso2_SeleccionProvinciaResidencia', livingProvince.label, 'Paso 2', subZone);
                }
                break;
        }
    };
    const handleDataLayer = (event, valor, subZona, isStep1) => {
        dataLayerService.sendEvent(event, {
            Seccion: '',
            SubSeccion: '',
            SubZona: subZona,
            TipoElemento: 'Desplegable',
            TipoEvento: 'Click',
            TipoZona: 'Onboarding Digital',
            Valor: valor,
            Zona: isStep1 ? 'Paso 1' : 'Paso 0'
        });
    };
    const handleDataLayerProvDistrict = (event, valor, stepValue, subZone) => {
        dataLayerService.sendEvent(event, {
            Seccion: '',
            SubSeccion: '',
            SubZona: subZone,
            TipoElemento: 'Desplegable',
            TipoEvento: 'Click',
            TipoZona: 'Onboarding Digital',
            Valor: valor,
            Zona: stepValue,
        });
    };
    const handleGetValue = () => {
        let valueFixed = value;
        let dataFound = data.find(element => element.value === value);
        if (dataFound)
            valueFixed = dataFound.label;
        const valueFixedFinal = toTitleCase(valueFixed);
        return valueFixedFinal;
    };
    const setInputsFocus = () => {
        const input = document.getElementById("custom-select-field_searchbar");
        if (input)
            input.focus();
    };
    return (_jsxs(ThemeProvider, { theme: CustomTheme, children: [_jsx(TextField, { id: "custom-text-field-select", className: 'custom-text-field custom-text-field-select', variant: "outlined", autoComplete: 'off', ...props, autoFocus: false, InputLabelProps: {
                    sx: {
                        color: '#212429',
                        '&.Mui-focused': {
                            marginTop: '10px',
                            color: 'transparent'
                        },
                        '&.MuiFormLabel-filled': {
                            marginTop: '10px',
                            color: '#434A54'
                        },
                    },
                }, InputProps: {
                    sx: {
                        marginTop: '0px',
                        '& input::placeholder': {
                            marginTop: '0px',
                            color: 'transparent'
                        },
                        backgroundColor: 'transparent',
                        borderRadius: '12px',
                    },
                    endAdornment: _jsx(InputAdornment, { position: "start", sx: { transform: 'rotate(180deg)' }, children: _jsx("img", { src: UpArrow, alt: 'up-icon' }) })
                }, value: handleGetValue(), onClick: () => {
                    setOpeSelectModal(true);
                    setInputsFocus();
                }, onFocus: () => {
                    setOpeSelectModal(true);
                    setInputsFocus();
                }, error: error, helperText: error && messageError ? (_jsx("div", { children: _jsx("span", { children: messageError }) })) : null }), _jsx(Modal, { open: opeSelectModal, onClose: closeModalOccupation, className: 'modal-occupation', children: _jsx(ThemeProvider, { theme: CustomTheme, children: _jsxs(Box, { sx: {
                            backgroundColor: '#FFFFFF',
                            color: '#434A54',
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            height: isMobile ? '80%' : '670px',
                            boxSizing: 'border-box',
                            width: isMobile ? '100%' : '360px',
                            borderTopRightRadius: '24px',
                            borderTopLeftRadius: '24px',
                            [theme.breakpoints.up(600)]: {
                                borderRadius: '24px',
                                left: '50%',
                                top: '50%',
                                transform: 'translate(-50%, -50%)',
                            },
                            '&.show': {
                                transform: 'translateY(0)',
                            },
                        }, children: [_jsxs(Box, { sx: {
                                    borderBottom: '1px solid #E6E9ED',
                                    padding: '20px',
                                    boxSizing: 'border-box'
                                }, children: [_jsxs(Box, { className: 'modal-occupation_title-container', sx: {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignContent: 'center',
                                            boxSizing: 'border-box',
                                            padding: '10px 0px'
                                        }, children: [_jsxs(Typography, { id: "custom-select-field_searchbar", variant: "body1", className: 'modal-occupation_label', sx: {
                                                    fontWeight: 700,
                                                    fontSize: '16px',
                                                    lineHeight: '24px'
                                                }, children: [" ", titleModal] }), _jsx("img", { src: CloseIcon, alt: 'close-icon-green', onClick: closeModalOccupation })] }), _jsx(TextField, { autoFocus: searchAutoFocusValue, id: "outlined-search", type: "search", color: "primary", autoComplete: 'off', InputLabelProps: {
                                            sx: {
                                                marginTop: '20px',
                                            }
                                        }, sx: {
                                            width: '100%',
                                            height: '48px',
                                        }, InputProps: {
                                            sx: {
                                                width: '100%',
                                                borderRadius: '12px',
                                                height: '48px',
                                                border: '0px',
                                            },
                                            startAdornment: _jsx(InputAdornment, { position: "start", children: _jsx("img", { src: SearchIcon, alt: 'search-icon' }) })
                                        }, onChange: isOcupation ? filterOccupation : filterPlaceofBirth })] }), !!imgAdvise && (_jsx("div", { className: 'head-container', children: _jsxs("div", { className: 'advise-card', role: "note", "aria-label": "Sugerencia de selecci\u00F3n", children: [_jsxs(Box, { className: 'advise-card__text', children: [_jsx("div", { className: 'advise-card__text__title', children: titleAdvise }), _jsx("div", { className: 'advise-card__text__subtitle', children: subtitleAdvise })] }), _jsx(Box, { className: 'advise-card__image', children: _jsx("img", { src: AdnThinking, alt: "Ilustraci\u00F3n de ayuda" }) })] }) })), _jsx(RadioGroup, { className: 'modal-occupation-list', "aria-labelledby": "demo-radio-buttons-group-label", name: "radio-buttons-group", value: dataSelected?.value, onChange: changeRadioButton, sx: {
                                    padding: '16px 20px 20px 24px'
                                }, children: filteredData.map(dataItem => {
                                    return (_jsx(FormControlLabel, { value: dataItem.value, control: _jsx(Radio, {}), label: toTitleCase(dataItem.label) }, `key_radio_${dataItem.value}`));
                                }) })] }) }) })] }));
};
export default CustomSelectField;
